
@file:Suppress("unused")
package tk.mallumo.compose.navigation


import tk.mallumo.compose.navigation.ArgumentsNavigation

fun ui.app.assign.AppAssignListingArgs.fill(bundle: ArgumentsNavigation): ui.app.assign.AppAssignListingArgs {
	companyId = bundle.long["companyId", companyId]
	return this
}
fun ui.app.assign.AppAssignListingArgs.asBundle() = ArgumentsNavigation().apply{
	this.long["companyId"] = this@asBundle.companyId
}
fun ui.app.assign.detail.AppDetailArgs.fill(bundle: ArgumentsNavigation): ui.app.assign.detail.AppDetailArgs {
	companyId = bundle.long["companyId", companyId]
	appId = bundle.long["appId", appId]
	return this
}
fun ui.app.assign.detail.AppDetailArgs.asBundle() = ArgumentsNavigation().apply{
	this.long["companyId"] = this@asBundle.companyId
	this.long["appId"] = this@asBundle.appId
}
fun ui.app.rss.AppRssListingArgs.fill(bundle: ArgumentsNavigation): ui.app.rss.AppRssListingArgs {
	companyId = bundle.long["companyId", companyId]
	return this
}
fun ui.app.rss.AppRssListingArgs.asBundle() = ArgumentsNavigation().apply{
	this.long["companyId"] = this@asBundle.companyId
}
fun ui.app.rss.instance.detail.AppRssDetailInstanceArgs.fill(bundle: ArgumentsNavigation): ui.app.rss.instance.detail.AppRssDetailInstanceArgs {
	id = bundle.long["id", id]
	return this
}
fun ui.app.rss.instance.detail.AppRssDetailInstanceArgs.asBundle() = ArgumentsNavigation().apply{
	this.long["id"] = this@asBundle.id
}
fun ui.app.visibility.AppVisibilityListingArgs.fill(bundle: ArgumentsNavigation): ui.app.visibility.AppVisibilityListingArgs {
	companyId = bundle.long["companyId", companyId]
	return this
}
fun ui.app.visibility.AppVisibilityListingArgs.asBundle() = ArgumentsNavigation().apply{
	this.long["companyId"] = this@asBundle.companyId
}
fun ui.campaign.CampaignListingArgs.fill(bundle: ArgumentsNavigation): ui.campaign.CampaignListingArgs {
	companyId = bundle.long["companyId", companyId]
	return this
}
fun ui.campaign.CampaignListingArgs.asBundle() = ArgumentsNavigation().apply{
	this.long["companyId"] = this@asBundle.companyId
}
fun ui.campaign.detailv2.editor.CampaignEditorArgs.fill(bundle: ArgumentsNavigation): ui.campaign.detailv2.editor.CampaignEditorArgs {
	companyId = bundle.long["companyId", companyId]
	campaignId = bundle.long["campaignId", campaignId]
	backStack = bundle.int["backStack", backStack]
	return this
}
fun ui.campaign.detailv2.editor.CampaignEditorArgs.asBundle() = ArgumentsNavigation().apply{
	this.long["companyId"] = this@asBundle.companyId
	this.long["campaignId"] = this@asBundle.campaignId
	this.int["backStack"] = this@asBundle.backStack
}
fun ui.campaign.detailv2.preview.CampaignPreviewArgs.fill(bundle: ArgumentsNavigation): ui.campaign.detailv2.preview.CampaignPreviewArgs {
	companyId = bundle.long["companyId", companyId]
	campaignId = bundle.long["campaignId", campaignId]
	campaignGroupId = bundle.long["campaignGroupId", campaignGroupId]
	return this
}
fun ui.campaign.detailv2.preview.CampaignPreviewArgs.asBundle() = ArgumentsNavigation().apply{
	this.long["companyId"] = this@asBundle.companyId
	this.long["campaignId"] = this@asBundle.campaignId
	this.long["campaignGroupId"] = this@asBundle.campaignGroupId
}
fun ui.company.detail.CompanyArgs.fill(bundle: ArgumentsNavigation): ui.company.detail.CompanyArgs {
	companyId = bundle.long["companyId", companyId]
	forceUpNavigation = bundle.boolean["forceUpNavigation", forceUpNavigation]
	return this
}
fun ui.company.detail.CompanyArgs.asBundle() = ArgumentsNavigation().apply{
	this.long["companyId"] = this@asBundle.companyId
	this.boolean["forceUpNavigation"] = this@asBundle.forceUpNavigation
}
fun ui.console.ConsoleArgs.fill(bundle: ArgumentsNavigation): ui.console.ConsoleArgs {
	mac = bundle.string["mac", mac]
	return this
}
fun ui.console.ConsoleArgs.asBundle() = ArgumentsNavigation().apply{
	this.string["mac"] = this@asBundle.mac
}
fun ui.dashboard.ArgsDashboard.fill(bundle: ArgumentsNavigation): ui.dashboard.ArgsDashboard {
	serverId = bundle.long["serverId", serverId]
	companyId = bundle.long["companyId", companyId]
	menuEntry = bundle.boolean["menuEntry", menuEntry]
	return this
}
fun ui.dashboard.ArgsDashboard.asBundle() = ArgumentsNavigation().apply{
	this.long["serverId"] = this@asBundle.serverId
	this.long["companyId"] = this@asBundle.companyId
	this.boolean["menuEntry"] = this@asBundle.menuEntry
}
fun ui.device.DeviceListingArgs.fill(bundle: ArgumentsNavigation): ui.device.DeviceListingArgs {
	companyId = bundle.long["companyId", companyId]
	locationId = bundle.long["locationId", locationId]
	showAll = bundle.boolean["showAll", showAll]
	return this
}
fun ui.device.DeviceListingArgs.asBundle() = ArgumentsNavigation().apply{
	this.long["companyId"] = this@asBundle.companyId
	this.long["locationId"] = this@asBundle.locationId
	this.boolean["showAll"] = this@asBundle.showAll
}
fun ui.device.detail.editor.DeviceEditorArgs.fill(bundle: ArgumentsNavigation): ui.device.detail.editor.DeviceEditorArgs {
	deviceId = bundle.long["deviceId", deviceId]
	registrationDeviceKey = bundle.string["registrationDeviceKey", registrationDeviceKey]
	return this
}
fun ui.device.detail.editor.DeviceEditorArgs.asBundle() = ArgumentsNavigation().apply{
	this.long["deviceId"] = this@asBundle.deviceId
	this.string["registrationDeviceKey"] = this@asBundle.registrationDeviceKey
}
fun ui.device.detail.DeviceArgs.fill(bundle: ArgumentsNavigation): ui.device.detail.DeviceArgs {
	deviceId = bundle.long["deviceId", deviceId]
	return this
}
fun ui.device.detail.DeviceArgs.asBundle() = ArgumentsNavigation().apply{
	this.long["deviceId"] = this@asBundle.deviceId
}
fun ui.hardware.detail.HardwareDetailArgs.fill(bundle: ArgumentsNavigation): ui.hardware.detail.HardwareDetailArgs {
	hardwareId = bundle.long["hardwareId", hardwareId]
	return this
}
fun ui.hardware.detail.HardwareDetailArgs.asBundle() = ArgumentsNavigation().apply{
	this.long["hardwareId"] = this@asBundle.hardwareId
}
fun ui.ArgsInitial.fill(bundle: ArgumentsNavigation): ui.ArgsInitial {
	cat = bundle.int["cat", cat]
	sub = bundle.int["sub", sub]
	key = bundle.string["key", key]
	return this
}
fun ui.ArgsInitial.asBundle() = ArgumentsNavigation().apply{
	this.int["cat"] = this@asBundle.cat
	this.int["sub"] = this@asBundle.sub
	this.string["key"] = this@asBundle.key
}
fun ui.license.detail.LicenseArgs.fill(bundle: ArgumentsNavigation): ui.license.detail.LicenseArgs {
	companyId = bundle.long["companyId", companyId]
	return this
}
fun ui.license.detail.LicenseArgs.asBundle() = ArgumentsNavigation().apply{
	this.long["companyId"] = this@asBundle.companyId
}
fun ui.location.LocationListingArgs.fill(bundle: ArgumentsNavigation): ui.location.LocationListingArgs {
	companyId = bundle.long["companyId", companyId]
	showAll = bundle.boolean["showAll", showAll]
	return this
}
fun ui.location.LocationListingArgs.asBundle() = ArgumentsNavigation().apply{
	this.long["companyId"] = this@asBundle.companyId
	this.boolean["showAll"] = this@asBundle.showAll
}
fun ui.location.detail.LocationArgs.fill(bundle: ArgumentsNavigation): ui.location.detail.LocationArgs {
	companyId = bundle.long["companyId", companyId]
	locationId = bundle.long["locationId", locationId]
	return this
}
fun ui.location.detail.LocationArgs.asBundle() = ArgumentsNavigation().apply{
	this.long["companyId"] = this@asBundle.companyId
	this.long["locationId"] = this@asBundle.locationId
}
fun ui.report.campaign.ReportCampaignArgs.fill(bundle: ArgumentsNavigation): ui.report.campaign.ReportCampaignArgs {
	companyId = bundle.long["companyId", companyId]
	campaignGroupId = bundle.long["campaignGroupId", campaignGroupId]
	withBackNav = bundle.boolean["withBackNav", withBackNav]
	return this
}
fun ui.report.campaign.ReportCampaignArgs.asBundle() = ArgumentsNavigation().apply{
	this.long["companyId"] = this@asBundle.companyId
	this.long["campaignGroupId"] = this@asBundle.campaignGroupId
	this.boolean["withBackNav"] = this@asBundle.withBackNav
}
fun ui.report.device.ReportDeviceArgs.fill(bundle: ArgumentsNavigation): ui.report.device.ReportDeviceArgs {
	deviceId = bundle.long["deviceId", deviceId]
	return this
}
fun ui.report.device.ReportDeviceArgs.asBundle() = ArgumentsNavigation().apply{
	this.long["deviceId"] = this@asBundle.deviceId
}
fun ui.resource.ResourceListingArgs.fill(bundle: ArgumentsNavigation): ui.resource.ResourceListingArgs {
	companyId = bundle.long["companyId", companyId]
	pickerMode = bundle.boolean["pickerMode", pickerMode]
	restrictionType = bundle.int["restrictionType", restrictionType]
	restrictionOrientation = bundle.int["restrictionOrientation", restrictionOrientation]
	restrictionAspectRatio = bundle.int["restrictionAspectRatio", restrictionAspectRatio]
	restrictionDurationMax = bundle.long["restrictionDurationMax", restrictionDurationMax]
	restrictionDurationMin = bundle.long["restrictionDurationMin", restrictionDurationMin]
	restrictionCanIgnoreAspectRatio = bundle.boolean["restrictionCanIgnoreAspectRatio", restrictionCanIgnoreAspectRatio]
	restrictionCanIgnoreDuration = bundle.boolean["restrictionCanIgnoreDuration", restrictionCanIgnoreDuration]
	excluded = bundle.string["excluded", excluded]
	return this
}
fun ui.resource.ResourceListingArgs.asBundle() = ArgumentsNavigation().apply{
	this.long["companyId"] = this@asBundle.companyId
	this.boolean["pickerMode"] = this@asBundle.pickerMode
	this.int["restrictionType"] = this@asBundle.restrictionType
	this.int["restrictionOrientation"] = this@asBundle.restrictionOrientation
	this.int["restrictionAspectRatio"] = this@asBundle.restrictionAspectRatio
	this.long["restrictionDurationMax"] = this@asBundle.restrictionDurationMax
	this.long["restrictionDurationMin"] = this@asBundle.restrictionDurationMin
	this.boolean["restrictionCanIgnoreAspectRatio"] = this@asBundle.restrictionCanIgnoreAspectRatio
	this.boolean["restrictionCanIgnoreDuration"] = this@asBundle.restrictionCanIgnoreDuration
	this.string["excluded"] = this@asBundle.excluded
}
fun ui.resource.detail.ResourceArgs.fill(bundle: ArgumentsNavigation): ui.resource.detail.ResourceArgs {
	companyId = bundle.long["companyId", companyId]
	resourceId = bundle.long["resourceId", resourceId]
	return this
}
fun ui.resource.detail.ResourceArgs.asBundle() = ArgumentsNavigation().apply{
	this.long["companyId"] = this@asBundle.companyId
	this.long["resourceId"] = this@asBundle.resourceId
}
fun ui.resource.editor.VisualEditorArgs.fill(bundle: ArgumentsNavigation): ui.resource.editor.VisualEditorArgs {
	companyId = bundle.long["companyId", companyId]
	resourceId = bundle.long["resourceId", resourceId]
	upStack = bundle.int["upStack", upStack]
	return this
}
fun ui.resource.editor.VisualEditorArgs.asBundle() = ArgumentsNavigation().apply{
	this.long["companyId"] = this@asBundle.companyId
	this.long["resourceId"] = this@asBundle.resourceId
	this.int["upStack"] = this@asBundle.upStack
}
fun ui.server.detail.ServerArgs.fill(bundle: ArgumentsNavigation): ui.server.detail.ServerArgs {
	serverId = bundle.long["serverId", serverId]
	return this
}
fun ui.server.detail.ServerArgs.asBundle() = ArgumentsNavigation().apply{
	this.long["serverId"] = this@asBundle.serverId
}
fun ui.user.UserListingArgs.fill(bundle: ArgumentsNavigation): ui.user.UserListingArgs {
	companyId = bundle.long["companyId", companyId]
	showAll = bundle.boolean["showAll", showAll]
	return this
}
fun ui.user.UserListingArgs.asBundle() = ArgumentsNavigation().apply{
	this.long["companyId"] = this@asBundle.companyId
	this.boolean["showAll"] = this@asBundle.showAll
}
fun ui.user.detail.UserArgs.fill(bundle: ArgumentsNavigation): ui.user.detail.UserArgs {
	userId = bundle.long["userId", userId]
	return this
}
fun ui.user.detail.UserArgs.asBundle() = ArgumentsNavigation().apply{
	this.long["userId"] = this@asBundle.userId
}
